/**
 * Adapter Context
 * React context for providing adapters to the application
 */

import { createContext } from 'react'
import type { ChatAdapters } from './types'

export const AdapterContext = createContext<ChatAdapters | null>(null)

